import { render, staticRenderFns } from "./rewardRankEdit.vue?vue&type=template&id=0f7af10e&scoped=true&"
import script from "./rewardRankEdit.vue?vue&type=script&lang=js&"
export * from "./rewardRankEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7af10e",
  null
  
)

export default component.exports